var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"alert-wrapper"},[_c('div',{staticClass:"alert-box"},[_c('NormalAlert')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }